const CalendarIcon = ({ size = 24, ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M3.09265 9.40445H20.9166"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.4421 13.3097H16.4514"
                stroke="#0069AD"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0046 13.3097H12.0139"
                stroke="#0069AD"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5579 13.3097H7.56717"
                stroke="#0069AD"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.4421 17.1964H16.4514"
                stroke="#BBD8ED"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0046 17.1964H12.0139"
                stroke="#0069AD"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.5579 17.1964H7.56717"
                stroke="#0069AD"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.0437 2V5.29078"
                stroke="#00A7E4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.96552 2V5.29078"
                stroke="#00A7E4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.2383 3.5791H7.77096C4.83427 3.5791 3 5.21504 3 8.22213V17.2718C3 20.3261 4.83427 21.9999 7.77096 21.9999H16.229C19.175 21.9999 21 20.3545 21 17.3474V8.22213C21.0092 5.21504 19.1842 3.5791 16.2383 3.5791Z"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CalendarIcon;